<template>
  <div>
    <b-card class="shadow" :header="card.product.name" v-if="renderComponent">
      <b-card-body class="p-0">
        <div v-if="card.debt" class="d-flex justify-content-center p-2">
          <p class="h5 mt-1">Борг : {{ card.debt }} грн</p>
          <b-button
            class="ms-3"
            variant="danger"
            size="sm"
            v-on:click="openControls(3)"
            >Доплата</b-button
          >
        </div>
        <b-row>
          <div v-if="!card.activated">
            <b-button variant="outline-success" v-on:click="activateCard">
              Активувати
            </b-button>
          </div>
        </b-row>
        <div
          v-if="card.visits_obj.length"
          class="d-flex justify-content-center"
        >
          <p class="mt-1">
            Останній візит : <strong>{{ lastVisit }}</strong>
          </p>
          <b-button
            class="ms-3 mb-2"
            @click="abortVisit"
            variant="outline-danger"
            size="sm"
          >
            Скасувати
          </b-button>
        </div>
        <div v-if="card.activated" class="p-1">
          <div v-if="card.total_visits !== 'unlimited'">
            <p>
              Лишилось визитів :
              <strong
                >{{ card.total_visits - card.visits }} /
                {{ card.total_visits }}</strong
              >
            </p>
          </div>
          <div v-else>
            <p v-if="card.visits > 0">
              Візитів : <strong>{{ card.visits }}</strong>
            </p>
          </div>
          <div>
            Закінчується : <strong>{{ card.expiration_date | moment }}</strong>
          </div>
          <div v-if="card.visits === card.total_visits" class="mt-4">
            <p>Не залишилось занять</p>
          </div>
          <div
            v-if="card.product.allowed_groups.length && validToVisit"
            class="mt-4"
          >
            <b-list-group v-for="group in validGroups" :key="group.id">
              <b-list-group-item button @click="registerVisit(group)">
                {{ group.name }} {{ group.time }}
              </b-list-group-item>
            </b-list-group>
          </div>
          <div
            v-if="!card.product.allowed_groups.length && validToVisit"
            class="mt-4"
          >
            <button
              class="rounded-lg bg-emerald-400 hover:scale-95 transition duration-300 p-2 text-white"
              @click="registerVisit()"
            >
              Зняти візит
            </button>
          </div>
          <div v-if="!validToVisit" class="mt-4">
            <p class="fw-bold h5">Для візита необхідно сплатити борг</p>
          </div>
        </div>
        <b-button class="mt-4" v-on:click="openControls(0)">
          Керування картою
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ClientCardInfo",
  props: {
    card: Object,
    clientId: Number,
  },
  data: function () {
    return {
      schedule: [],
      chosenGroup: null,
      renderComponent: true,
    };
  },
  computed: {
    lastVisit: function () {
      let lastVisitDate = new Date(this.card.visits_obj.at(-1).time);
      let today = new Date();
      if (lastVisitDate.toDateString() === today.toDateString()) {
        return "Сьогодні";
      }
      return lastVisitDate.toLocaleDateString("ru");
    },
    validToVisit: function () {
      if (
        !this.card.debt ||
        !this.card.visits ||
        this.card.total_visits === "unlimited"
      ) {
        return true;
      }
      let oneVisitCost =
        (this.card.amount + this.card.debt) / this.card.total_visits;
      let visitsCost = this.card.visits * oneVisitCost;
      return (
        this.card.amount + this.card.debt - this.card.debt - visitsCost >=
        oneVisitCost
      );
    },
    validGroups: function () {
      let valid = [];
      this.card.product.allowed_groups.forEach((group) => {
        this.schedule.forEach((training) => {
          if (group.id === training.group_id) {
            valid.push({
              id: training.id,
              name: training.name,
              time: moment(training.time).format("HH:mm"),
            });
          }
        });
      });
      return valid.sort(function (a, b) {
        return a.time.split(":")[0] - b.time.split(":")[0];
      });
    },
  },
  async mounted() {
    await this.fetchTodaySchedule();
  },
  methods: {
    async fetchTodaySchedule() {
      let response = await this.$api.schedule.getTodaySchedule();
      this.schedule = response.data;
    },
    async registerVisit(group) {
      let result;
      if (group) {
        result = confirm(
          `Відмітити візит ${new Date(Date.now()).toLocaleString("uk")} на ${group.name} ?`,
        );
      } else {
        result = confirm(
          `Відмітити визит ${new Date(Date.now()).toLocaleString("uk")} ?`,
        );
      }
      if (!result) return;
      let payload = {
        card_id: this.card.id,
        client_id: this.card.client_id,
      };
      if (group) {
        payload.group_id = group.id;
      }
      await this.$api.visits.registerVisit(payload);
      this.$emit("refresh");
      this.$emit("showModal", "Візит відмічено!", "green");
    },
    async activateCard() {
      let result = confirm(`Активувати карту ${this.card.product.name} ?`);
      if (!result) return;
      await this.$api.activecards.activateCard(this.card.id);
      this.$emit("refresh");
      this.$emit("showModal", "Карта активована!", "green");
      this.$forceUpdate();
    },
    async abortVisit() {
      await this.$api.visits.abortVisit(this.card.visits_obj.at(-1).id);
      this.$emit("refresh");
    },
    openControls(tab) {
      this.$emit("openControls", this.card, tab);
    },
  },
  filters: {
    moment(date) {
      return moment(date).locale("uk").format("DD MMMM YYYY");
    },
  },
};
</script>

<style scoped></style>
